var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnassignedView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5556 15V13.5555C12.5556 11.96 11.2622 10.6666 9.66667 10.6666H3.88889C2.2934 10.6666 1 11.96 1 13.5555V15",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7778 7.77778C8.37329 7.77778 9.66669 6.48438 9.66669 4.88889C9.66669 3.2934 8.37329 2 6.7778 2C5.18232 2 3.88892 3.2934 3.88892 4.88889C3.88892 6.48438 5.18232 7.77778 6.7778 7.77778Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8936 2.8285C12.2449 1.82968 13.2655 1.2299 14.309 1.4089C15.3526 1.5879 16.1149 2.49349 16.1134 3.55231C16.1134 4.99993 13.9419 5.72374 13.9419 5.72374",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.61914V8.25723",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnassignedView);
export default __webpack_public_path__ + "static/media/unassigned-view.3db27e30.svg";
export { ForwardRef as ReactComponent };